import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import StatusBadge from "./StatusBadge";

export default function CaseContextHeader({ caseDoc }) {
  if (!caseDoc) return null;
  return (
    <Card className="mb-6" data-testid="case-context-header">
      <CardContent className="p-4">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <span className="kbd">{caseDoc.case_type}</span>
              <span className="text-xs text-muted-foreground">·</span>
              <span className="font-mono text-sm font-semibold">{caseDoc.case_number}/{caseDoc.case_year}</span>
              <StatusBadge status={caseDoc.case_status} />
            </div>
            <div className="text-sm font-medium" data-testid="case-subject">{caseDoc.subject_title}</div>
            <div className="text-xs text-muted-foreground">
              {caseDoc.district} · {caseDoc.taluka} · {caseDoc.village} · {caseDoc.legal_act} {caseDoc.legal_section}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
